var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDot = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 4,
  height: 4,
  viewBox: "0 0 4 4",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.382812 2.28149V1.96118C0.382812 1.51326 0.523438 1.14347 0.804688 0.851807C1.09115 0.56014 1.47917 0.414307 1.96875 0.414307C2.46354 0.414307 2.85417 0.56014 3.14062 0.851807C3.42708 1.14347 3.57031 1.51326 3.57031 1.96118V2.28149C3.57031 2.7242 3.42708 3.09139 3.14062 3.38306C2.85938 3.66951 2.47135 3.81274 1.97656 3.81274C1.48698 3.81274 1.09896 3.66951 0.8125 3.38306C0.526042 3.09139 0.382812 2.7242 0.382812 2.28149Z",
  fill: "black"
})));
export default SvgIconDot;